import React, { useState, useEffect, useContext, useRef } from 'react'
import { useTranslation } from 'react-i18next';

import styles from '../styles.module.css'
import { mainContext } from '../../../../MainContext';
import FadeinWrap from '../../../../../common/animation/FadeinWrap';


function Customer9() {
  const { t } = useTranslation();

  const isWide = useContext(mainContext).isWide;
  const langCode = useContext(mainContext).langCode;

  const name1Ref = useRef(null);
  const [name1Height, setName1Height] = useState(0);
  const name2Ref = useRef(null);
  const [name2Height, setName2Height] = useState(0);

  const [label, setLabel] = useState(t('customer.customer9.label'));
  const [name, setName] = useState(t('customer.customer9.name'));


  useEffect(() => {
    setTimeout(() => {
      setLabel(t('customer.customer9.label'));
      setName(t('customer.customer9.name'));
    }, 500)
  }, [langCode])



  useEffect(() => {
    if(name1Ref.current) {
      setName1Height(name1Ref.current.offsetHeight);
    }
  }, [isWide, label, name1Ref, name1Ref.current])

  useEffect(() => {
    if(name2Ref.current) {
      setName2Height(name2Ref.current.offsetHeight);
    }
  }, [isWide, name, name2Ref, name2Ref.current])


  return (
    <div className={styles.customerItemWrap}>
      <div className={styles.customerProfileWrap}>
        <div className={styles.background}></div>
        <div className="col-12 col-md-8 ms-auto me-auto">
          <div className='row w-100 m-0'>
            <div className='col-12 col-md-9'>
              <FadeinWrap>
                <img src="./img/customer/customer9.png" class="w-100" alt="日吉聖美" />
              </FadeinWrap>
            </div>
            <div className='col-12 col-md-3'>
              <div className={styles.customerNameWrap}>
                <div style={{height: isWide? name1Height : '100%'}}>
                  <p ref={name1Ref} className={styles.customerName}>{label}</p>
                </div>
                {(langCode=='ja' || langCode=='en') &&
                  <div style={{height: isWide? name2Height : '100%'}}>
                    <p ref={name2Ref} className={styles.customerName}>{name}</p>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.customerVoice} mb-0`}>
        <p className="mb-0">
          {t('customer.customer9.content').split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>
      </div>
    </div>
  );
}

export default Customer9;